module.exports = __webpack_public_path__ + "components/tide-table/static/moon-new-moon-9295ae113e698636926d60b8d6cd6e7e.svg";